import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import {
    BackgroundColorDirective,
    DcSelectedTheme,
    DcThemeService,
    RadioButtonComponent,
    TypographyDirective,
} from '@dartcounter/ui';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleSwitchComponent } from 'src/app/shared/components/toggle-switch/toggle-switch.component';
import { SlideDialogLayoutComponent } from 'src/app/shared/dialogs/slide-dialog-layout/slide-dialog-layout.component';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
    selector: 'app-theme-preference-dialog',
    templateUrl: './theme-preference.dialog.html',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        SlideDialogLayoutComponent,
        TypographyDirective,
        RadioButtonComponent,
        ToggleSwitchComponent,
        BackgroundColorDirective,
    ],
})
export class ThemePreferenceDialogComponent {
    private themeService: DcThemeService = inject(DcThemeService);
    private modalService: ModalService = inject(ModalService);

    public selectedTheme: Signal<DcSelectedTheme> = computed(() => this.themeService.selectedTheme());
    public accessibilityMode: Signal<boolean> = computed(() => this.themeService.accessibilityMode());

    public images: Signal<{ light: string; dark: string; system: string }> = computed(() => {
        const basePath = 'assets/images/themes';
        const addition = this.accessibilityMode() ? '_accessibility' : '';
        return {
            light: `${basePath}/light${addition}.webp`,
            dark: `${basePath}/dark${addition}.webp`,
            system: `${basePath}/system${addition}.webp`,
        };
    });

    public changeTheme(theme: DcSelectedTheme): void {
        this.themeService.set(theme);
    }

    public toggleAccessibilityMode(): void {
        this.themeService.toggleAccessibilityMode();
    }

    public dismiss(): void {
        this.modalService.dismiss();
    }
}
